import { useContext } from 'react';
import { DialogActionContext, DialogContext } from '.';
export function useDialogs() {
  const context = useContext(DialogContext);
  if (!context) {
    throw new Error("useDialogs must be used within a DialogProvider");
  }
  return context;
}
export function useDialogActions() {
  const context = useContext(DialogActionContext);
  if (!context) {
    throw new Error("useDialogAction must be used within a DialogActionProvider");
  }
  return context;
}